import { Component, computed, input, output } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'

/**
 * The save bar a settings form ends with - every Moja prevádzka tab and Môj profil (Figma: "Koncept 3 · Pravidlá a
 * náhľad", node 90:10988): whether there are unsaved changes, "Zrušiť zmeny" and "Uložiť zmeny". Place it inside the
 * `<form>`: its save button is a `type="submit"`, so it submits that form, and Enter in a field does too.
 *
 * `problem` is why the form cannot be saved, shown in place of the "unsaved" message. Material shows a field's own
 * error only once the field is touched, so without it a stored value that broke a newer rule would leave a disabled
 * button and nothing on screen saying why.
 */
@Component({
  selector: 'seiri-save-bar',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './save-bar.component.html',
  styleUrl: './save-bar.component.css',
})
export class SaveBarComponent {
  readonly changed = input.required<boolean>()
  readonly invalid = input(false)
  readonly submitting = input(false)
  readonly problem = input('')
  readonly discard = output<void>()

  protected readonly message = computed(() => {
    if (this.invalid() && this.problem()) return this.problem()
    return this.changed() ? 'Máte neuložené zmeny' : 'Všetky zmeny sú uložené'
  })
  protected readonly warning = computed(() => this.changed() || (this.invalid() && !!this.problem()))
}
